// listType-URL-Parameter: steuert, welche Angebotstypen die Kursliste zeigt.
//  - "courses"  = nur reguläre Kurse (keine Interessenten-Listen)
//  - "interest" = nur Interessenten-Listen
//  - "all"      = gemischt (URL-Fallback)

export type ListType = "courses" | "interest" | "all"

export const DEFAULT_LIST_TYPE: ListType = "all"

/**
 * Robustes Parsen des URL-Parameters. Unbekannte/leere Werte fallen auf den
 * Default "all" zurück, damit Integratoren mit Tippfehlern nichts ausblenden.
 */
export function parseListType(raw: string | null | undefined): ListType {
    switch ((raw ?? "").trim().toLowerCase()) {
        case "courses":
            return "courses"
        case "interest":
            return "interest"
        case "all":
            return "all"
        default:
            return DEFAULT_LIST_TYPE
    }
}

/**
 * Löst den effektiven Angebotstyp auf. Nur ein vollständig fehlender
 * URL-Parameter verwendet den Tenant-Standard. Explizite, aber leere oder
 * ungültige Werte behalten den robusten URL-Fallback "all".
 *
 * `showInterestListsByDefault !== false` ist absichtlich defensiv: Fehlt das
 * neue Setting während eines gestaffelten Rollouts, bleibt das bisherige
 * Verhalten erhalten.
 */
export function resolveListType(
    raw: string | null | undefined,
    showInterestListsByDefault: boolean | null | undefined
): ListType {
    if (raw === null || raw === undefined) {
        return showInterestListsByDefault !== false ? "all" : "courses"
    }

    return parseListType(raw)
}

export const showRegularCourses = (listType: ListType): boolean => listType !== "interest"
export const showInterestLists = (listType: ListType): boolean => listType !== "courses"
